import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Icon } from 'antd';
import classNames from 'classnames/bind';
import styles from '../../emailTemplates.less';

const cx = classNames.bind(styles);

const Folders = ({
  setSelectedFolderData, selectedFolder, folders, isSharedByVisible, queryByPaging
}) => (
  <div className={cx('folders')}>
    {folders.map((item, index) => (
      <div key={item.id} className={cx('folder')} style={{ marginLeft: index > 0 ? 40 : 10 }}>
        <div
          className={cx('folder-wrap')}
          onClick={() => {
            setSelectedFolderData(item);
            queryByPaging({ folderId: item.id });
          }}
        >
          <Icon
            className={cx('folder-icon')}
            type={selectedFolder && selectedFolder.id === item.id ? 'folder-open' : 'folder'}
          />
          {(!_.isEmpty(item.shared_to_users) || !_.isEmpty(item.shared_to_teams)) && !isSharedByVisible &&
            <Icon type="export" />
          }
        </div>
        <div>
          {item.name}
        </div>
        {isSharedByVisible && item.belonged_user &&
          <FormattedMessage id="page.emailTemplates.by">
            {text => <span>{text + item.belonged_user.name}</span>}
          </FormattedMessage>
        }
      </div>
      ))}
  </div>
);

export default Folders;



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/Folders/folder.js